import React, { useContext, useState } from 'react';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router';
import { completedRoutes } from '../../../common/constants';
import Execute from '../UserPayment/Execute';
import Container from '@material-ui/core/Container';
import ModalItem from '../../common/ModalItem/ModalItem';
import { Hidden } from '@material-ui/core';
import IsMobileContext from '../../../common/IsMobileContext';
import { useTranslation } from 'react-i18next';
import UserPlacesItem from './UserPlacesItem';
import './user-places.scss';
import { uniq } from 'lodash';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";

const ContentSwitch = (props) => {
  const { desktopOption, content } = props;

  return (
    <Switch>
      <Route path={completedRoutes.userPaymentExecute}>
        <Execute />
      </Route>
      {desktopOption &&
      <Route>
        {content}
      </Route>
      }
    </Switch>
  );
};

function UserPlaces(props) {
  const isMobileDesign = useContext(IsMobileContext);
  const { t } = useTranslation();
  const [typeFilter, setTypeFilter] = useState(t('userPlaces.allSelect'));
  const [checkbox, setCheckbox] = useState({ task: false, score: false });

  const {
    userPlacesById, userPlacesAllIds,
  } = props;

  const typeNames = uniq(userPlacesAllIds.map((placeId) => {
    const placeData = userPlacesById[placeId];
    return placeData.typename;
  }));

  const handleSelectType = (e) => {
    const { value } = e.target;
    setTypeFilter(value);
  };

  const handleSelectCheckbox = (name) => (e) => {
    const { checked } = e.target;
    setCheckbox({ ...checkbox, [name]: checked });
  };

  const content = (
    <Container className="user-places-container">
      <h2>{t('userPlaces.h')}</h2>
      <div className="content">
        <div className="select">
          <FormControl variant="outlined">
            <Select
              native
              value={typeFilter}
              onChange={handleSelectType}
            >
              <option value={t('userPlaces.allSelect')}>{t('userPlaces.allSelect')}</option>
              {typeNames.map((i) => <option key={i} value={i}>{i}</option>)}
            </Select>
          </FormControl>
        </div>
        <FormGroup className="check-controls">
          <FormControlLabel
            control={<Checkbox
              style={{ width: 36, height: 36 }}
              icon={<CheckBoxOutlineBlankIcon style={{ fontSize: 20 }} />}
              checkedIcon={<CheckBoxIcon style={{ fontSize: 20, color: '#000' }} />}
              checked={checkbox.task}
              onChange={handleSelectCheckbox('task')}
            />}
            label={t('userPlaces.check1')}
          />
          {/*<FormControlLabel*/}
          {/*  control={<Checkbox*/}
          {/*    checked={checkbox.score}*/}
          {/*    onChange={handleSelectCheckbox('score')}*/}
          {/*  />}*/}
          {/*  label={t('userPlaces.check2')}*/}
          {/*/>*/}
        </FormGroup>
        {userPlacesAllIds.map((id) => {
          const place = userPlacesById[id];
          const { typename, active_task_count: activeTaskCount } = place;
          if (typeFilter !== t('userPlaces.allSelect') && typename !== typeFilter) return null;
          if (checkbox.task && activeTaskCount < 1) return null;
          return <UserPlacesItem key={`place-${id}`} item={place} />;
        })}
      </div>
    </Container>
  );

  return (
    <ModalItem>
      <>
        <Hidden mdUp>
          {content}
        </Hidden>
        <ContentSwitch desktopOption={!isMobileDesign} content={content} />
      </>
    </ModalItem>
  );
}

const mapStateToProps = (state) => {
  const { places } = state;
  return {
    userPlacesById: places.userPlaces.byId,
    userPlacesAllIds: places.userPlaces.allIds,
  }
};

const actionCreators = {};

export default connect(mapStateToProps, actionCreators)(UserPlaces);
